import { ConfigService } from './configs/config.service';


export {
    ConfigService,
}